import PropTypes from "prop-types";

function LocationUrlCard({ locationUrl }) {
  return (
    <iframe
      className="rounded-lg"
      src={locationUrl}
      width="100%"
      height="380"
      style={{ border: 0 }}
      allow="fullscreen"
      loading="lazy"
      role="presentation"
    ></iframe>
  );
}

LocationUrlCard.propTypes = {
  locationUrl: PropTypes.string,
};

LocationUrlCard.defaultProps = {
  locationUrl:
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14600.300452637322!2d90.4212875!3d23.8159279!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6c13ca0026ba4d75!2sRoboDoc%20Limited!5e0!3m2!1sen!2sbd!4v1648036952201!5m2!1sen!2sbd",
};

export default LocationUrlCard;
